import React from 'react';
import { SingleCommonType } from '../../types';
import { steamPurchasePlaceholder } from '../../constants/placeholder';
import CommonSingleSelect from '../../components/CommonSingleSelect';
import { steamPurchaseOptions } from '../../constants/steamPurchase';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function SteamPurchaseSelect(props: SingleCommonType) {
  return (
    <CommonSingleSelect
      {...props}
      returnKey="steam_purchase"
      dealwithReturnValue={(value) => Number(value)}
      singlePlaceholder={steamPurchasePlaceholder}
      options={steamPurchaseOptions}
      pointKey={FilterButtonPoint.steamPurchase}
      initValue="0"
    />
  );
}
